const ADD_TO_FAVORITES_ACTION = 'ADD_TO_FAVORITES';

export { ADD_TO_FAVORITES_ACTION };
